import api from './api';

/**
 * Appels de l'écran « Accès clients » (lot 053): qui peut ouvrir le portail,
 * pour quel client, jusqu'à quand. Aucun libellé d'écran ici.
 */
const lire = (reponse) => reponse.data?.data;

export const accesClientsAPI = {
  async lister() {
    return lire(await api.get('/client-access-policies')) || [];
  },

  async options() {
    return lire(await api.get('/client-access-policies/options')) || { portal_users: [], clients: [], trucks: [] };
  },

  async voyagesDuClient(clientId) {
    return lire(await api.get('/client-access-policies/client-trips', { params: { client_id: clientId } })) || [];
  },

  async donner(corps) {
    return lire(await api.post('/client-access-policies', corps));
  },

  async modifier(id, changements) {
    return lire(await api.patch(`/client-access-policies/${id}`, changements));
  },

  async retirer(id) {
    await api.delete(`/client-access-policies/${id}`);
  },
};

/** « 2026-12-31 » (champ date) -> fin de journée, en heure universelle. */
export const finDeJournee = (jour) => (jour ? `${jour}T23:59:59+00:00` : null);

/** Fin d'accès renvoyée par le serveur -> valeur d'un champ date. */
export const jourDeFin = (valeur) => (valeur ? String(valeur).slice(0, 10) : '');

export default accesClientsAPI;
